import { CollectionContentTypes, type PageSetCollections } from '@pressreader/social-types';

import type { WithCollectionsDto } from '../types';

import { mapCollectionsDto } from './collections.common';

export function mapPageSetCollections(pageSetId: string, objWithCollections: WithCollectionsDto): PageSetCollections {
    return {
        ...mapCollectionsDto(objWithCollections),
        pageSetId,
        collectionContent: CollectionContentTypes.pageSet,
    };
}
